import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Information_xs = (props) => {
    const width = props.width ? props.width + 'px' : '16px';
    const height = props.height ? props.height + 'px' : '16px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 16 16"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                d="M7 5.5C7 4.94772 7.44771 4.5 8 4.5C8.55228 4.5 9 4.94772 9 5.5C9 6.05229 8.55228 6.5 8 6.5C7.44771 6.5 7 6.05229 7 5.5Z"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.75 8C14.75 11.7279 11.7279 14.75 8 14.75C4.27208 14.75 1.25 11.7279 1.25 8C1.25 4.27208 4.27208 1.25 8 1.25C11.7279 1.25 14.75 4.27208 14.75 8ZM8 13.25C10.8995 13.25 13.25 10.8995 13.25 8C13.25 5.10051 10.8995 2.75 8 2.75C5.10051 2.75 2.75 5.1005 2.75 8C2.75 10.8995 5.1005 13.25 8 13.25ZM8 11.75C7.58579 11.75 7.25 11.4142 7.25 11L7.25 8C7.25 7.58579 7.58579 7.25 8 7.25C8.41421 7.25 8.75 7.58579 8.75 8L8.75 11C8.75 11.4142 8.41421 11.75 8 11.75Z"
            />
        </SvgStyled>
    );
};

export default Information_xs;
